import * as React from 'react';
import { GridDayProps } from '../../components/grid/day';
import moment from 'moment';
import { LoadMoreProps } from '../../components/month-selection/load-more';
import { scrollToMonth } from '../../helpers/scroll-to-month';

const NextMonthView: React.StatelessComponent<LoadMoreProps> = props => {
    function onClick(evt: React.MouseEvent<HTMLButtonElement>) {
        evt.preventDefault();

        props.goToNextMonth();
        const nextMonth = props.currDate.clone().add(1, "month").startOf("month");

        var focusDestinationMonth = setInterval(() => {
            if (scrollToMonth(nextMonth)) {
                clearInterval(focusDestinationMonth);
            }
        }, 500);

    }

    return (
        <button className="ace-cal-list-load-more btn-outline space-top-lg" type="button" onClick={onClick}>
            {props.text.loadMoreEventsButtonText}
        </button>
    );
}

export default NextMonthView;